/**
 * UUID v4 format regex
 * Format: 8 hex digits, followed by three groups of 4 hex digits,
 * followed by 12 hex digits
 * The third group starts with 4 and the fourth group starts with 8 or 9 or a or b
 */
export const UUID_V4_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Validates if a string is a valid UUID v4
 * @param id - The string to validate
 * @returns boolean - True if the string is a valid UUID v4
 */
export const isValidUUID = (id: string): boolean => {
  return typeof id === "string" && UUID_V4_REGEX.test(id);
};
